import React from 'react'
import cx from 'classnames'

import { TItem } from '../../types'

const CertsAndAppsAreaItem: React.FC<{
  item: TItem
  index: number
  type: 'cert' | 'app'
  uid: string | null
}> = (props) => {
  const src = [props.item.image, props.uid].filter(Boolean).join('?')
  return (
    <li
      className={cx('sm:h-32 md:h-40', {
        'h-32': props.type === 'cert',
        'h-40': props.type === 'app',
        'ml-16': props.index > 0,
      })}
    >
      <a href={`${props.item.url}`}>
        <img src={src} alt={props.item.label} className="h-full" />
      </a>
    </li>
  )
}

export { CertsAndAppsAreaItem as default }
